import classNames from 'classnames/bind';

import { Stream } from 'types/stream';

import { getLumeoFileIdFromStreamUri } from 'services/stream';
import { useHasAccess } from 'hooks/useHasAccess';

import { IconButton } from 'components/IconButton/IconButton';
import { FileActions } from 'files/components/FileActions/FileActions';

import styles from './Table.module.scss';

const c = classNames.bind(styles);

export type FilesOverviewTableActionsCellProps = {
  file: Stream;
  onViewClick: () => void;
  onRenameClick: (fileID: string | undefined) => void;
};

export function FilesOverviewTableActionsCell({
  file: fileStream,
  onViewClick,
  onRenameClick,
}: FilesOverviewTableActionsCellProps) {
  const [hasAccess] = useHasAccess();

  const fileId = getLumeoFileIdFromStreamUri(fileStream);

  return (
    <div className={c('actions')}>
      <IconButton
        icon="eye"
        onClick={onViewClick}
        label="View file"
        disabled={!fileId}
        disabledTooltip="Unsupported media type"
      />
      {hasAccess('deploy_edit') && (
        <FileActions file={fileStream} onRenameClick={onRenameClick} />
      )}
    </div>
  );
}
